export default "__VITE_ASSET__wroUn2cQ__"